import React, {Component} from 'react';

import Headline from '../Headline/Headline'
import styles from './Error404.css'

export default class Error404 extends Component {
    render() {

        return (
            <div className={styles.container}>
                <Headline>Error 404 - Seite wurde nicht gefunden</Headline>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Error404/Error404.js